import { render, staticRenderFns } from "./BaseParams.vue?vue&type=template&id=9d33bf48&scoped=true"
import script from "./BaseParams.vue?vue&type=script&lang=js"
export * from "./BaseParams.vue?vue&type=script&lang=js"
import style0 from "./BaseParams.vue?vue&type=style&index=0&id=9d33bf48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d33bf48",
  null
  
)

export default component.exports